import { PersonInfo } from 'src/Context';
import { TITLE_TEMPLATE, DESCRIPTION } from '@api/constants/other';

enum Share {
  'facebook',
  'whatsapp',
  'twitter',
}

enum Modal {
  'video',
  'person',
}

export type ShareType = keyof typeof Share;
export type ModalType = keyof typeof Modal;

export const share = (type: ShareType, person: PersonInfo, modalType: ModalType) => {
  const domain = `${window.location.origin}${window.location.pathname}`;
  const title = TITLE_TEMPLATE.replace('{name}', `${person?.b || ''} ${person?.c || ''}`)
    .replace('{role}', `${person?.a}` || '')
    .replace('{city}', person?.f ? `מ${person?.f}` : '')
    .replace(/  +/g, ' ');
  const encode = encodeURIComponent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const domainWithParams = `${domain}api/share?p=${person.id}&t=${modalType}`;
  const text = `${title}. ${DESCRIPTION}\n${domainWithParams}`;

  if (type === 'facebook') {
    const fbURL = 'https://www.facebook.com/sharer.php?u=';

    window.open(`${fbURL}${domainWithParams}`, 'sharer', 'width=555,height=600');
  }

  if (type === 'whatsapp') {
    const waShareLink = `https://wa.me/?text=${encode(`${text}`)}`;
    if (!isMobile) {
      window.open(waShareLink, '_blank');
    } else {
      window.location.href = waShareLink;
    }
  }

  if (type === 'twitter') {
    const twURL = 'https://twitter.com/intent/tweet?url=';
    const finalURL = `${twURL}${domainWithParams}&text=${encode(`${text}`)}`;

    const shareWindow = window.open(finalURL, 'ShareOnTwitter', 'width=555,height=600');
    if (shareWindow) shareWindow.opener = null;
  }
};
